module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.b1382ce3.webp";